module.exports = __webpack_public_path__ + "media/neon.aa6e0409.mp4";